import { z } from 'zod';

/**
 * Пакеты единиц (§39). Пакеты могут отличаться ценой за единицу —
 * это не тарифная система, тарифов в продукте нет (§32).
 */
export interface UnitPackageView {
  id: string;
  title: string;
  units: number;
  /** Цена в минорных единицах валюты. Наружу отдаём в валюте. */
  price: number;
  currency: string;
  /** Цена одной единицы — чтобы пользователь видел выгоду крупного пакета. */
  pricePerUnit: number;
  isBest: boolean;
}

export const checkoutSchema = z.object({ packageId: z.string().min(1) }).strict();

export interface CheckoutResult {
  paymentId: string;
  /** Куда вести пользователя. У демо-оплаты пусто. */
  redirectUrl: string | null;
  status: 'pending' | 'paid';
}

export interface PaymentView {
  id: string;
  units: number;
  amount: number;
  currency: string;
  status: 'pending' | 'paid' | 'failed' | 'cancelled' | 'refunded';
  createdAt: string;
  paidAt: string | null;
}

/** Только вне продакшна: заменяет собой вебхук платёжного провайдера. */
export const mockPaySchema = z.object({ paymentId: z.string().min(1) }).strict();

/** Расчёт стоимости до запуска (§36). */
export interface CostEstimateLine {
  operation: string;
  title: string;
  quantity: number;
  units: number;
}

export interface CostEstimate {
  lines: CostEstimateLine[];
  totalUnits: number;
  available: number;
  enough: boolean;
  missing: number;
}
